import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router/index.js'
import { i18n } from './i18n/index.js'
import './styles/main.scss'
import 'virtual:uno.css'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)

// A component error should not white-screen the panel. In development it is
// re-thrown so the overlay still shows it.
app.config.errorHandler = (error, _instance, info) => {
  console.error('[app error]', info, error)
  if (import.meta.env.DEV) throw error
}

app.mount('#app')
